import { render, staticRenderFns } from "./CoursePackage.vue?vue&type=template&id=169ea84a&scoped=true"
import script from "./CoursePackage.vue?vue&type=script&lang=js"
export * from "./CoursePackage.vue?vue&type=script&lang=js"
import style0 from "./CoursePackage.vue?vue&type=style&index=0&id=169ea84a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169ea84a",
  null
  
)

export default component.exports